import getSuitCSSClasses from '@/utils/getSuitCSSClasses';
import { ContentCards } from '@hz-design-system/web-ui';

type ListingsWrapperProps = {
  isListView: boolean;
  children: React.ReactNode;
  className?: string;
};

const ListingsWrapper = ({ isListView, children, className }: ListingsWrapperProps) => {
  return isListView ? (
    <ul className={className}> {children} </ul>
  ) : (
    <div className={getSuitCSSClasses({ namespace: 'hz', name: 'card-container' })}>
      <ContentCards kind="grid" as="ul">
        {' '}
        {children}{' '}
      </ContentCards>
    </div>
  );
};
export default ListingsWrapper;
